import { Link } from 'react-router-dom';
import { categories, siteIntro } from '@/mocks/videos';
import { useFormSubmit } from '@/hooks/useFormSubmit';

const NEWSLETTER_URL = 'https://readdy.ai/api/form/db4niu6k6jkc2oct49a0';

export default function Footer() {
  const { status, error, submit } = useFormSubmit(NEWSLETTER_URL);

  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-accent-500 text-background-50">
                <i className="ri-play-fill text-xl" />
              </span>
              <span className="font-heading text-lg font-extrabold text-foreground-950">
                啪啪<span className="text-accent-500">视频</span>
              </span>
            </Link>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 max-w-xs">
              {siteIntro.intro}
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-950 mb-4">
              <a href="#footer-nav" className="hover:text-accent-500">快速导航</a>
            </h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/" className="text-foreground-600 hover:text-accent-500 transition-colors">首页</Link></li>
              <li><Link to="/search" className="text-foreground-600 hover:text-accent-500 transition-colors">搜索发现</Link></li>
              <li><Link to="/about" className="text-foreground-600 hover:text-accent-500 transition-colors">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-950 mb-4">
              <a href="#footer-cat" className="hover:text-accent-500">视频分类</a>
            </h4>
            <ul className="space-y-2.5 text-sm">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link to={`/category/${cat.id}`} className="text-foreground-600 hover:text-accent-500 transition-colors">
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-950 mb-4">
              <a href="#footer-sub" className="hover:text-accent-500">订阅更新</a>
            </h4>
            <p className="text-sm text-foreground-600 mb-3">留下邮箱，第一时间收到最新热门影片推荐。</p>
            <form id="pv-newsletter-form" data-readdy-form action={NEWSLETTER_URL} onSubmit={submit} className="space-y-2">
              <input
                type="text"
                name="website_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="pv-form-note"
              />
              <div className="flex flex-col sm:flex-row gap-2">
                <input
                  type="email"
                  name="email"
                  required
                  placeholder="你的邮箱地址"
                  className="flex-1 min-w-0 h-10 px-3 text-sm rounded-md bg-background-50 border border-background-200/70 text-foreground-900 placeholder:text-foreground-500 outline-none focus:border-accent-500"
                />
                <button
                  type="submit"
                  disabled={status === 'loading'}
                  className="h-10 px-4 rounded-md bg-accent-500 text-background-50 text-sm font-semibold whitespace-nowrap hover:bg-accent-600 transition-colors disabled:opacity-60"
                >
                  {status === 'loading' ? '提交中…' : '订阅'}
                </button>
              </div>
              {status === 'success' && <p className="text-xs text-accent-500">订阅成功，感谢关注！</p>}
              {status === 'error' && <p className="text-xs text-accent-400">{error || '提交失败，请稍后重试'}</p>}
            </form>
          </div>
        </div>
      </div>

      <div className="border-t border-background-200/70">
        <div className="px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">© 2026 啪啪视频 · 本站内容均为演示数据，仅供学习展示</p>
          <p className="text-xs text-foreground-500">高清视频资源分享与在线播放平台</p>
        </div>
      </div>
    </footer>
  );
}